import type { IProfaseArchivo } from './profase-archivo-api';

export function isPdfFile(nombre: string): boolean {
  return nombre.toLowerCase().endsWith('.pdf');
}

export function isTxtFile(nombre: string): boolean {
  return nombre.toLowerCase().endsWith('.txt');
}

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'] as const;

export function isImageFile(nombre: string): boolean {
  const lower = nombre.toLowerCase();
  return IMAGE_EXTENSIONS.some(ext => lower.endsWith(ext));
}

export function canPreviewArchivo(
  archivo: IProfaseArchivo | null,
  canDownload: (archivo: IProfaseArchivo | null) => archivo is IProfaseArchivo,
): archivo is IProfaseArchivo {
  return canPreviewNombre(archivo?.nombre ?? '')
    && canDownload(archivo);
}

export function canPreviewNombre(nombre: string): boolean {
  return isPdfFile(nombre) || isTxtFile(nombre) || isImageFile(nombre);
}
